import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },

  paper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: theme.palette.background.paper,
    border: '2px solid theme.palette.primary.main',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    maxHeight: '80vh',
    width: '40vh',
    borderColor: theme.palette.secondary.main,
  },

  modalWrapper: {
    display: 'flex',
    flexDirection: 'column',
    height: '600px',
    width: '40vw',
  },

  headerWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },

  titleWrapper: {
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(1.25, 2.5),
  },

  buttonClose: {
    width: '1rem',
    height: '3rem',
    fontWeight: '800',
    margin: theme.spacing(0.4),
  },

}));

export default useStyles;
